var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 8.25H9.625V16.5H8.25V8.25Z",
    fill: "#E66666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 8.25H13.75V16.5H12.375V8.25Z",
    fill: "#E66666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 4.125V5.5H4.125V19.25C4.125 19.6147 4.26987 19.9644 4.52773 20.2223C4.78559 20.4801 5.13533 20.625 5.5 20.625H16.5C16.8647 20.625 17.2144 20.4801 17.4723 20.2223C17.7301 19.9644 17.875 19.6147 17.875 19.25V5.5H19.25V4.125H2.75ZM5.5 19.25V5.5H16.5V19.25H5.5Z",
    fill: "#E66666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 1.375H13.75V2.75H8.25V1.375Z",
    fill: "#E66666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.e9639c48fdf2c16ccb9626e832f27b39.svg";
export { ForwardRef as ReactComponent };